import { authHeader, handleResponse } from '../helpers'

export const washStationService = {
    getWashStations
};

function getWashStations() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/washstation`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}
